import { useQuery } from '@tanstack/react-query';

import { tagKeys } from '@/shared/lib/query/queryKeys';

import type { TagDetailItem } from '@/entities/tags/domain';

import { searchTagsApi } from '@/features/tags/api/searchTagsApi';

type UseTagsByCategoryParams = {
  parent: string;
  query?: string;
  provider?: 'system' | 'user';
};

type TagsResponse = {
  data: TagDetailItem[];
  paging: {
    total: number;
  };
};

export const useTagsByCategoryDetail = ({ parent, query = '', provider }: UseTagsByCategoryParams) => {
  return useQuery<TagsResponse>({
    queryKey: tagKeys.tagsByCategoryDetail(parent, query, provider),
    queryFn: () => searchTagsApi({ parent, query, provider }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
